import { useEffect, useState } from 'react'
import { api, storageUrl } from '../../../lib/api.js'
import {
  DEFAULT_HERO, DEFAULT_ABOUT, DEFAULT_CLIENTS,
  DEFAULT_SCHEDULE, DEFAULT_TEAM, DEFAULT_GALLERY,
  ASSETS,
} from '../constants.js'

export function useLandingData() {
  const [heroImages, setHeroImages] = useState(DEFAULT_HERO)
  const [aboutImages, setAboutImages] = useState(DEFAULT_ABOUT)
  const [clientLogos, setClientLogos] = useState(DEFAULT_CLIENTS)
  const [kelasData, setKelasData] = useState(DEFAULT_SCHEDULE)
  const [teamImages, setTeamImages] = useState(DEFAULT_TEAM)
  const [galleryImages, setGalleryImages] = useState(DEFAULT_GALLERY)

  // Hero carousel state
  const [heroIdx, setHeroIdx] = useState(0)
  const [flashing, setFlashing] = useState(false)
  const [playing, setPlaying] = useState(true)

  useEffect(() => {
    Promise.allSettled([
      api.get('/public/image-types/hero_background/images').then((r) => {
        if (r.data.images?.length)
          setHeroImages(r.data.images.map((i) => storageUrl(i.url)))
      }),

      api.get('/public/image-types/about_image/images').then((r) => {
        if (r.data.images?.length) {
          const sorted = [...r.data.images].sort((a, b) => a.sort_order - b.sort_order)
          const arr = sorted.map((i) => storageUrl(i.url))
          while (arr.length < 3) arr.push(arr[0] || ASSETS.imgPanjang)
          setAboutImages(arr)
        }
      }),

      api.get('/public/image-types/client_logo/images').then((r) => {
        if (r.data.images?.length)
          setClientLogos(r.data.images.map((i) => ({ id: i.id, name: i.title || 'Mitra', logo: storageUrl(i.url) })))
      }),

      api.get('/public/kelas').then((r) => {
        if (r.data.data?.length)
          setKelasData(
            r.data.data.map((k) => ({
              id: `s-${k.id}`,
              title: k.title,
              deskripsi: k.deskripsi,
              kategori: Array.isArray(k.kategori) ? k.kategori : [],
              rating: k.rating ?? 5.0,
              image_url: storageUrl(k.image_url),
              duration: '6 Bulan Pendidikan',
              certified: true,
              reviews: 0,
            }))
          )
      }),

      api.get('/public/image-types/team_photo/images').then((r) => {
        if (r.data.images?.length)
          setTeamImages(
            r.data.images.map((img) => ({
              id: `t-${img.id}`,
              title: img.title || 'Marketing',
              subtitle: img.description?.replace(/^Visi: "/, '').replace(/"$/, '') || '',
              description: img.description || '',
              url: storageUrl(img.url),
            }))
          )
      }),

      api.get('/public/image-types/gallery/images').then((r) => {
        if (r.data.images?.length)
          setGalleryImages(r.data.images.map((img) => ({ id: `g-${img.id}`, title: img.title || '', url: storageUrl(img.url) })))
      }),
    ])
  }, [])

  // Auto-advance hero every 6 s
  useEffect(() => {
    if (heroImages.length < 2 || !playing) return
    const iv = setInterval(() => {
      setFlashing(true)
      setTimeout(() => setHeroIdx((p) => (p + 1) % heroImages.length), 150)
      setTimeout(() => setFlashing(false), 300)
    }, 6000)
    return () => clearInterval(iv)
  }, [heroImages.length, playing])

  return {
    heroImages, aboutImages, clientLogos, kelasData, teamImages, galleryImages,
    heroIdx, setHeroIdx,
    flashing,
    playing, togglePlay: () => setPlaying((v) => !v),
  }
}
